import React from 'react'
import { formatDateUTC } from 'src/utils/formatDate'
import { ReceivementField } from '../ReceivementField'
import * as S from './ReceivementInfo.styles'

interface Props {
    operator?: string
    supervisor?: string;
    supplier?: string;
    dock?: string;
    receivementId?: string;
    duration?: string;
    startDate?: Date;
}

const ReceivementInfo = ({
  operator, supervisor, supplier, dock, receivementId, duration, startDate,
}: Props) => (
  <S.Container>
    {operator && <ReceivementField field='Operador:' value={operator}/>}
    {supervisor && <ReceivementField field='Fiscal:' value={supervisor}/>}
    {supplier && <ReceivementField field='Fornecedor:' value={supplier}/>}
    {dock && <ReceivementField field='Doca:' value={dock}/>}
    {receivementId && <ReceivementField field='Recebimento:' value={receivementId}/>}
    {duration && <ReceivementField field='Duração:' value={duration}/>}
    {startDate && <ReceivementField field='Data do recebimento:' value={formatDateUTC(startDate).toString()}/>}
  </S.Container>
)

export { ReceivementInfo }
